export const device = {
  desktop: "screen and (min-width: 1221px)",
  smallDesktop: "screen and (max-width: 1220px)",
  tablet: "screen and (max-width: 1024px)",
  phone: "screen and (max-width: 600px)",
}
